<template>
  <div class="natural-container">
    <div class="natural-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/programme_img5.png"
        alt="" class="pc-banner" />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/solution_nature_banner_mobile.png"
        class="mobile-banner" alt="">
      <div class="text-block">
        <div class="title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">
          自然资源执法
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          联合卫星、无人机、视频监控为一体的“空天地”一体化智能监测
        </div>
      </div>
    </div>

    <div class="industry-block type-block">
      <div class="industry-title page-block-title">传统执法方式及问题</div>
      <div class="industry-content pc-carousel">
        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/nature_problem1.png"
            alt="" />
          <div class="text-block">
            <div class="title">卫星监测</div>
            <div class="desc">图像分辨率较低，数据更新频率不足，影响细节监测，对细微变化的识别能力有限。</div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/nature_problem2.png"
            alt="" />
          <div class="text-block">
            <div class="title">人工巡逻</div>
            <div class="desc">高人力物力投入，效率较低；难以覆盖所有重点区域，尤其是偏远地区。</div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/nature_problem3.png"
            alt="" />
          <div class="text-block">
            <div class="title">视频监测 </div>
            <div class="desc">摄像头安装的位置固定，影响覆盖效果，山地及偏远地区受限明显</div>
          </div>
        </div>
      </div>
      <mobileCarousel class="mobile-carousel"></mobileCarousel>
    </div>

    <!-- 解决思路 -->
    <div class="solution-wrap">
      <div class="application-scenarios">
        <div class="application-title page-block-title">解决思路</div>
        <div class="application-desc page-block-desc ">
          以“一张图”数据为支撑，整合现有资源，将卫星、无人机、视频监控数据有效接入整合，构建以遥感影像监测、无人机监测和视频监测为一体的智能监察监管体系。将业务数据与各种监测手段结合起来，充分应用智能监测系统可视、直观、实时、精准等特点，实现不同监测手段间的无缝衔接和有机关联。
        </div>
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution_idea.png"
          class="solution1" alt="">
        <img src="../../assets/images/process_img1.png" class="solution1-mobile" alt="">

      </div>

      <!-- <div class="application-scenarios application-airplane">
        <div class="application-title">无人机执行任务流程</div>
         <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/process.png" class="solution1 airplane-task"   alt="">   
         <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/process_img2.png" class="solution1-mobile" alt="">    
    </div> -->
    </div>

    <div class="case-advantage-wrap">
      <div class="case-advantage-title page-block-title">我们的优势</div>
      <div class="case-advantage-content">
        <div class="case-advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/advantage_icon1.png"
            alt="">
          <div class="advantage-title">巡逻视域时域全覆盖</div>
          <div class="case-advantage-desc">无人机网格化巡逻实现全市范围的高频次、全时段巡逻，确保每个网格区域得到有效监控。</div>
        </div>

        <div class="case-advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/advantage_icon2.png"
            alt="">
          <div class="advantage-title">应急响应更快</div>
          <div class="case-advantage-desc">通过无人机指挥系统能够调度无人机迅速响应巡察核查事件，提高处理能力。
          </div>
        </div>

        <div class="case-advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/advantage_icon3.png"
            alt="">
          <div class="advantage-title">防范能力更强</div>
          <div class="case-advantage-desc">AI系统对异常行为进行自动预警，帮助提前识别潜在风险，提升安全防范能力。</div>
        </div>
      </div>
    </div>

    <!-- 方案应用 -->
    <div class="case-application pc-case">
      <div class="case-application-title page-block-title">方案应用</div>
      <div class="block-content">
        <div class="content-block">
          <div class="row-left-block wow fadeInLeft">
            <div class="block-box">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/case1.png"
                  alt="" />
              </div>
              <div class="block-text">
                <div class="title">实时监控</div>
                <div class="desc">
                  提供无人机巡逻区域的实时视图，支持实时数据分析和决策。
                </div>
              </div>
            </div>
          </div>
          <div class="row-right-block wow fadeInRight">
            <div class="block-box">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/case2.png"
                  alt="" />
              </div>
              <div class="block-text">
                <div class="title">集中控制</div>
                <div class="desc">
                  通过控制台集中管理所有无人机的飞行任务和数据流，实现对全辖区巡逻任务的实时调度。 
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-block">
          <div class="row-left-block wow fadeInLeft">
            <div class="block-box">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/case3.png"
                  alt="" />
              </div>
              <div class="block-text">
                <div class="title">AI智能识别分析</div>
                <div class="desc">
                  集成深度学习算法，能够识别违规行为、非法建筑和异常活动等。
                </div>
              </div>
            </div>
          </div>
          <div class="row-right-block wow fadeInRight">
            <div class="block-box">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/case4.png"
                  alt="" />
              </div>
              <div class="block-text">
                <div class="title">与执法系统对接</div>
                <div class="desc">
                  将无人机获取的数据与卫星图斑核查、日常巡查等业务系统进行整合，实现数据共享和业务协同。
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="content-block">
          <div class="row-left-block wow fadeInLeft">
            <div class="block-text">
              <div class="title">集中控制</div>
              <div class="desc">通过控制台集中管理所有无人机的飞行任务和数据流，实现对全辖区巡逻任务的实时调度。 </div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/case2.png" alt="" />
            </div>
          </div>
        </div> -->

        <!-- <div class="content-block">
          <div class="row-left-block wow fadeInLeft">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/case3.png" alt="" />
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="block-text">
              <div class="title">AI智能识别分析</div>
              <div class="desc">
                集成深度学习算法，能够识别违规行为、非法建筑和异常活动等。
              </div>
            </div>
          </div>
        </div> 

        <div class="case-application content-block">
          <div class="row-left-block wow fadeInLeft">
            <div class="block-text">
              <div class="title">与执法系统对接</div>
              <div class="desc">将无人机获取的数据与卫星图斑核查、日常巡查等业务系统进行整合，实现数据共享和业务协同。</div>
            </div>
          </div>
          <div class="row-right wow fadeInRight">
            <div class="img-wrap">
              <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/case4.png" alt="" />
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="mobile-case case-application">
      <div class="case-application-title">方案应用</div>
      <caseCarousel class="case-carousel"></caseCarousel>
    </div>


  </div>
</template>

<script>
import { WOW } from "wowjs";
import mobileCarousel from './components/natural-carousel.vue'
import caseCarousel from "./components/case-carousel.vue"

export default {
  components: {
    mobileCarousel,
    caseCarousel
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
};
</script>

<style lang="stylus" scoped>
.natural-container {
    .natural-banner {
        height:100vh;
        position:relative;
        @keyframes zoomIn {
            0% {
              transform: scale(1.1); 
            }
            100% {
                transform: scale(1); 
            }
        }
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            z-index: 2;
            color:#fff;
            text-align:center;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:734px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
        }
    }
    .type-block {
        margin-top:3.375rem !important;
    }

    .industry-block {
        max-width:var(--main-width);
        width:84%;
        margin:0 auto 4.93rem;
        .mobile-carousel {
          display:none;
        }
        .industry-title {
            position:relative;
            position:relative;
            text-align:center;
            font-weight:bold;
        }
    .industry-content {
        display:flex;
        margin-top:4.56rem;
        flex-wrap:nowrap;
        justify-content:center;
        .industry-item {
            width:30%;
            margin-right:33px;
            img {
                margin-bottom:0.875rem;
                width:100%;
            }
            .text-block {
                text-align:center;
                .title {
                    font-size:1.375rem;
                    font-weight:bold;
                    margin-bottom:10px;
                    color:#333;
                }
                .desc {
                 color:#666666;
                 font-size:14px;
                }
            }
        }
    }
    }
    .application-airplane {
      margin-top:0rem !important;
    }
    .solution-wrap {
      background-size:cover;
      background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/nature_bg.png");
    .application-scenarios {
        margin: 6.25rem auto 0;
        max-width:var(--main-width);
        width:84%;
        .application-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            font-weight:bold;
            margin-bottom:3.18rem;
        }
        .application-desc {
            text-align: center;
            margin:0 auto;
            letter-spacing: 1px;
            line-height:25px;
        }
        .application-content {
            display:flex;
            justify-content: space-around;
            gap: 1.875rem;
            flex-wrap: wrap;
            max-width:var(--main-width);
            width:84%;
            margin:2.375rem auto 7.5rem;
            .application-block {
                width: 30%;
                max-width: 27rem;
                min-width: 23.75rem;
                position:relative;
                display:flex;
                justify-content: center;
                align-items:center;
                overflow:hidden;
                .text {
                    position:absolute;
                    bottom:0px;
                    width:100%;
                    color:#fff;
                    text-align: center;
                    line-height: 87px;
                    background: linear-gradient( 180deg, rgba(39,39,39,0) 0%, rgba(14,14,14,0.7) 100%);
                }
            }
        }
        .solution1 {
            max-width:95%;
            margin:7rem 0 7rem;
        }
        .solution1-mobile {
          display:none;
        }
        .airplane-task {
          margin-top:5rem;
        }
    }
  }

    .mobile-case {
      display:none;
    }
    .case-application {
      .case-application-title {
            position:relative;
            position:relative;
            text-align:center;
            letter-spacing:2px;
            font-weight:bold;
        }
      .block-content {
        max-width:var(--main-width);
        width:84%;
        margin:7.56rem auto 0;
         .content-block {
            margin-bottom:3.5rem;
            display:flex;
            justify-content:space-between;
            flex-wrap: wrap;
            >div {
                width:46%;
                img {
                  width: 100%;
                  height: auto; /* 自动调整高度以保持比例 */
                  object-fit: cover; /* 等比例缩放并覆盖 */
                }
            }
            .row-left-block {
            }
            .block-text {
                padding:3rem 3.5rem;
                .title {
                    color:#2372E9;
                    margin-bottom:1rem;
                    font-size:1.5rem;
                    font-weight:bold;
                    text-align:center;
                }
                .desc {
                    color:#333333;
                    line-height:30px;
                    font-size:1rem;
                    text-align:center;
                }
            }
        }
    }
    }
  
}
.case-advantage-wrap {
    padding:5.18rem 0 4.13rem;
    .case-advantage-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            margin-bottom:3.18rem;
            font-weight:bold;
        }
       
    .case-advantage-content {
        display:flex;
        max-width:var(--main-width);
        width:84%;
        margin:3.31rem auto 0;
        justify-content: space-around;
    }
    .case-advantage-block:hover {
      background-color:#F5F7FA;
      .advantage-title {
        color:#2372E9;
      }
      .advantage-title::after {
        background-color:#2372E9;
      }
      .case-advantage-desc {
        color:#666666;
      }
    }
    .case-advantage-block {
        position:relative;
        text-align: center;
        padding:3.81rem 0 3.75rem;
        display:flex;
        border-radius: 0.75rem 0.75rem 0.75rem 0.75rem;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width:21.25rem;
        .advantage-title {
            margin-top:19px;
            color:#666;
            font-size:1.375rem;
            position:relative;
            margin-bottom:2.5rem;
        }
        .advantage-title::after {
            position:absolute;
            content:"";
            bottom:-20px;
            left:50%;
            transform: translateX(-50%);
            width: 40px;
            height:1px;
            background-color: #666666;
        }
        .case-advantage-desc {
            color:#666666;
            line-height:25px;
            max-width:17.5rem;
            font-size:14px;
        }
    }

}
@media only screen and (max-width: 768px) {
  .natural-banner {
    height:380px !important;
    margin-top:108px;
    .text-block {
      margin-top:0 !important;
      width:80%;
      .title {
        font-size:2rem !important;
      }
      .desc {
        width:100% !important;
        font-size:1.125rem !important;
        line-height:22px !important;
      }
    }
  }
  .industry-block{
    padding:0px 12px 0;
    max-width:100% !important;
    width:auto !important;
    margin:0 !important;
    .mobile-carousel {
      display:block !important;
    }
    .pc-carousel {
      display:none !important;
    }
    .industry-title {
      font-size:22px !important;
      margin-top:0px !important;
      font-weight:bold;
    }
    .industry-title::after {
      top:50px !important;
    }
    .industry-content {
      display:none !important;
    }
  }
.solution-wrap {
  .application-scenarios {
      margin-top:0px !important;
      padding:0 15px;
      width:auto !important;
      .application-content {
        width:100% !important;
        gap:0 !important;
        margin:2.375rem auto !important;
      }
      .solution1 {
        display:none !important;
      }
      .solution1-mobile {
        display:block !important;
        margin:2.93rem auto;
      }
      .application-title {
        font-size:22px !important;
        margin-top:0px !important;
        font-weight:bold;
      }
      .application-title::after {
        top:50px !important;
      }
      .application-desc {
        font-size:14px !important;
        color:#666;
      }
      .application-block {
        max-width:30% !important;
        min-width:30% !important;
        margin-bottom:20px;
        .text {
          width:108px !important;
          line-height:25px !important; 
        }
      }
    }
  }
  .mobile-case {
    padding:0 13px;
  }
  .pc-case {
    display:none;
  }
  .mobile-case {
    display:block !important;
    margin-bottom:36px;
  }
  .case-carousel {
    margin-top:40px;
  }
  .case-advantage-wrap {
      padding:0 0 2.125rem;
      .case-advantage-title {
        font-size:22px !important;
        margin-top:0px !important;
        font-weight:bold;
      }
      .case-advantage-title::after {
        top:50px !important;
      }
      .case-advantage-content {
        flex-wrap:wrap !important;
        width:100%;
        margin:3.68rem auto 0;
        .case-advantage-block {
          margin-bottom:30px;
          padding:0 !important;
          .advantage-title {
             color:#222;
             font-size:18px;
             font-weight:bold;
            }
            .case-advantage-desc {
               font-size:13px;
               line-height:19px;
               width:100%;
            }
        }
      }
    }
    .case-application-title {
      font-size:22px !important;
        margin-top:0px !important;
        font-weight:bold;
        }
        .case-application-title::after {
          top:50px !important;
    }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
  .content-block > div {
    padding: 0 1rem; 
}
}

</style>
